import React, { useEffect, useRef } from 'react';

import { Box } from '@mui/material';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

import { LocationMarker } from '@modules/_shared/components/Mapbox';
import { MAPBOX_TOKEN } from '@shared/config';

type ZoningMapProps = {
  lat: number;
  lng: number;
  zoom?: number;
};

export const ZoningMap = ({ lat, lng, zoom = 16 }: ZoningMapProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const mapRef = useRef<mapboxgl.Map | null>(null);
  const [mapLoaded, setMapLoaded] = React.useState(false);

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    const map = new mapboxgl.Map({
      container: containerRef.current,
      accessToken: MAPBOX_TOKEN,
      attributionControl: false,
      style: 'mapbox://styles/spingwun/cjoeeyssz16n82rlmpsofotvw',
      center: [lng, lat],
      zoom,
      pitch: 45,
      bearing: 0,
    });

    map.addControl(new mapboxgl.NavigationControl({}));

    map.on('load', () => {
      setMapLoaded(true);
    });

    mapRef.current = map;

    return () => {
      map.remove();
      mapRef.current = null;
      setMapLoaded(false);
    };
  }, [lat, lng, zoom]);

  return (
    <Box sx={{ height: '100%', position: 'relative' }}>
      <Box
        ref={containerRef}
        sx={{
          position: 'absolute',
          left: 0,
          width: '100%',
          height: '100%',
        }}
      />
      {mapLoaded && <LocationMarker mapRef={mapRef} lat={lat} lng={lng} />}
    </Box>
  );
};
